import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFacebookRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		fill: "#0866ff",
		d: "M26.6 15.5a11.3 11.3 0 1 0-14 11V19h-2.4v-3.5h2.4V14q-.1-5.6 5.5-5.6l2.4.3v3.1h-1.3q-2.6-.1-2.5 2.5v1.2h3.6l-.6 3.5h-3v7.7c5.5-.6 9.9-5.4 9.9-11.2"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "m19.7 19 .6-3.5h-3.6v-1.2q-.1-2.6 2.5-2.5h1.3V8.7l-2.4-.3q-5.6 0-5.5 5.6v1.5h-2.4V19h2.4v7.5a11 11 0 0 0 4 .2V19z"
	})]
});
export default SvgFacebookRegularIcon;
